<template>
  <div id="app">
    <header class="bg-white header">
      <router-link to="/">
        <img src="./assets/svg/logo.svg">
      </router-link>
    </header>
    <div v-if="updateAvailable" class="update-banner">
      <span>Der er en ny version af siden.</span>
      <button type="button" class="update-banner__btn" @click="refreshPage">Opdater</button>
    </div>

    
    
    <router-view/>
  </div>
</template>

<script>
import { checkAirportsDataVersion } from "./utils/airportsVersionCheck";

export default {
  name: 'App',
  data() {
    return {
      updateAvailable: false,
      updateCheckTimer: null,
      currentAppScript: null
    };
  },
  watch: {
    '$route.query': {
      handler (query) {
        if (!document.cookie.includes('ref=') && query.ref) {
          const expires = (new Date(Date.now() + 86400 * 21000)).toUTCString() // 21 day
          document.cookie = `ref=${query.ref}; expires=${expires}; path=/;`
        }
      },
      deep: true,
      immediate: true
    }
  },

  created () {
    // Check airports data version on app startup
    checkAirportsDataVersion();

    // Start update checker (compares current app bundle to latest index.html)
    this.currentAppScript = this.getAppScriptSrc(document);
    this.startUpdateCheck();
    
    setTimeout (() => {
      this.$router.go()
    }, 10800000)
  },
  mounted() {
    if (!this.currentAppScript) {
      this.currentAppScript = this.getAppScriptSrc(document);
    }
    if (typeof window !== 'undefined') {
      window.__valizoApp = this;
    }
  },
  beforeDestroy() {
    if (this.updateCheckTimer) {
      clearInterval(this.updateCheckTimer);
      this.updateCheckTimer = null;
    }
  },
  methods: {
    getAppScriptSrc(doc) {
      if (!doc) return null;
      const scripts = Array.from(doc.querySelectorAll('script[src]'));
      const appScript = scripts.find((s) => /(^|\/)app(\.[a-f0-9]+)?\.js/.test(s.getAttribute('src')));
      if (appScript) {
        return appScript.getAttribute('src');
      }
      const vendorScript = scripts.find((s) => /(^|\/)chunk-vendors(\.[a-f0-9]+)?\.js/.test(s.getAttribute('src')));
      return vendorScript ? vendorScript.getAttribute('src') : null;
    },
    async checkForUpdate() {
      if (this.updateAvailable) return;
      try {
        const response = await fetch(`/index.html?update_check=${Date.now()}`, { cache: 'no-store' });
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const latestScript = this.getAppScriptSrc(doc);
        if (latestScript && this.currentAppScript && latestScript !== this.currentAppScript) {
          this.updateAvailable = true;
        }
      } catch (error) {
        // Ignore update check errors to avoid breaking the app
      }
    },
    startUpdateCheck() {
      this.checkForUpdate();
      this.updateCheckTimer = setInterval(() => this.checkForUpdate(), 60000);
    },
    refreshPage() {
      window.location.reload(true);
    }
  }
}
//https://booking.valizo.eu/#/book?post_n=1234&amt_people=1&ref=vladislav
</script>

<style lang="scss" scoped>
  .header {
    padding: 32px 60px;
    border-bottom: 1px solid #E2E2E2;
  }

  .update-banner {
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    background: #2f3b50;
    color: #fff;
    padding: 10px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 10px 30px rgba(47,59,80,0.2);
    z-index: 2000;
    font-size: 14px;
  }

  .update-banner__btn {
    border: 0;
    background: #2EA3F2;
    color: #fff;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
  }

  @media (max-width: 600px) {
    .update-banner {
      left: 12px;
      right: 12px;
      bottom: 16px;
      transform: none;
      width: auto;
      justify-content: space-between;
      gap: 8px;
    }
  }
</style>
